/* eslint-disable no-tabs */
import React from 'react';
import { segmentTrackEvent } from '../utils';

const Lander = ({
  hed,
  hed2,
  subHed,
  author,
  titleTag,
  bgImage,
  isMobile,
  renderedSectionHeads,
  onButtonClick,
}) => {
  // TODO update tracking
  const sectionTracker = {
    module: 'destiLander',
    category: 'open-section',
    linkType: 'open-section',
    label: `scroll-to-section-buttons`,
  };

  let headline = isMobile ? <h1 className='lander-hed'>Build<br></br>a better<br></br>bbq</h1> : <h1 className='lander-hed'>{hed}</h1>;
  let subheadline = isMobile ? <h1 className='lander-subhed'>12 Tasty<br></br>Grilling Recipes</h1> : <h1 className='lander-subhed'>{hed2}</h1>;

  const renderedLanderHeroText = <div className='lander-text-wrapper'>{headline}<div className="lander-line"></div>{subheadline}</div>;

  return (
    <div className='lander'>
			<div className='lander-wrapper'>
				{renderedLanderHeroText}
        {isMobile && <div className='lander-arrow-button arrow' onClick={() => { segmentTrackEvent('lander_arrow_clicked', sectionTracker); onButtonClick(); }}></div>}
        {!isMobile
          && <div className='lander-section-buttons-wrapper'>
            {renderedSectionHeads}
          </div>
        }
      </div>
		</div>
  );
};

export default Lander;
